export default function Dashboard(props) {
  return <div>Dashboard</div>;
}
